<div class="auth-container referral-code-container">
  <div>
    <h1 class="primary-font-semibold heading">
      {{ 'authentication.referral_code_title' | translate }}
    </h1>
    <p class="primary-font-medium form-description">
      {{ 'authentication.referral_code_description' | translate }}
    </p>
  </div>

  @if (shouldShowValidationErrors) {
    <div class="error-message-container">
      @if (errorMessage) {
        <p class="error-message primary-font-medium form-description">
          {{ errorMessage }}
        </p>
      }
    </div>
  }

  <form
    [formGroup]="referralCodeForm"
    class="form-container"
    (ngSubmit)="handleReferralCodeSubmission().subscribe()"
    autocomplete="off"
  >
    <div class="form-group">
      <label class="primary-font-medium form-label" for="referralCode">{{
        'authentication.enter_referral_code_label' | translate
      }}</label>
      <input
        type="text"
        id="referralCode"
        formControlName="referralCode"
        class="form-input primary-font-medium"
        [class.error-input]="
          referralCodeForm.get('referralCode')?.invalid && shouldShowValidationErrors
        "
        [placeholder]="'authentication.enter_referral_code' | translate"
      />
      @if (
        referralCodeForm.get('referralCode')?.hasError('invalidReferralCode') &&
        shouldShowValidationErrors
      ) {
        <div class="error-message-container">
          <span class="error-message primary-font-regular">{{
            getFieldErrorMessage('referralCode') | translate
          }}</span>
        </div>
      }
    </div>

    <div class="button-container referral-code-button-container">
      <button
        type="submit"
        class="auth-button primary-button custom-button rounded-pill primary-font-medium"
        [disabled]="!referralCodeForm.get('referralCode')?.value"
      >
        @if (!isSubmitting) {
          {{ 'authentication.submit_button' | translate }}
        }
        @if (isSubmitting) {
          <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
        }
      </button>
      <button
        type="button"
        class="auth-button secondary-button custom-button rounded-pill primary-font-medium"
        (click)="skipReferralHandling.emit()"
      >
        {{ 'authentication.skip_button' | translate }}
      </button>
    </div>
  </form>
</div>
